import React, { useState, useEffect } from 'react';
import './navbar.scss';
import gold_logo from '../../../assets/images/gold_logo.png';
import { FiLogOut } from 'react-icons/fi';
import Cookies from 'js-cookie';
import { useNavigate, useLocation } from 'react-router-dom';

const Navbar = () => {
  const [isMobile, setIsMobile] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const isHomePage = location.pathname === '/';
  const isAdminPath = location.pathname.startsWith('/admin');
  const isLoginPage = location.pathname === '/admin/login';

  // ✅ Check login state on every route change
  useEffect(() => {
    const token = Cookies.get('auth');
    setIsLoggedIn(!!token);

    // ✅ Redirect from /admin/login to /admin/add-review if already logged in
    if (token && isLoginPage) {
      navigate('/admin/add-review');
    }
  }, [location, navigate, isLoginPage]);

  const toggleMenu = () => {
    setIsMobile(!isMobile);
  };

  const closeMenu = () => {
    setIsMobile(false);
  };

  const scrollToSection = (sectionClass) => {
    const element = document.querySelector(`.${sectionClass}`);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      closeMenu();
    }
  };

  const handleLogout = () => {
    Cookies.remove('auth');
    setIsLoggedIn(false);
    navigate('/admin/login');
  };

  const goToAddReview = () => {
    navigate('/admin/add-review');
  };

  const goToAddPhotos = () => {
    navigate('/admin/add-photos');
  };

  return (
    <header className="navbar">
      {/* Logo always visible */}
      <div className="logo">
        <img src={gold_logo} alt="Logo" />
      </div>

      {/* ❌ Don't show nav items on login page */}
      {!isLoginPage && (
        <div className={`nav-links ${isMobile ? 'mobile' : ''}`}>
          {isMobile && (
            <button className="close-btn" onClick={closeMenu}>
              &times;
            </button>
          )}

          <ul>
            {isHomePage && (
              <>
                <li>
                  <button onClick={(e) => { e.preventDefault(); scrollToSection('home-section1'); }}>Home</button>
                </li>
                <li>
                  <button onClick={(e) => { e.preventDefault(); scrollToSection('home-section4'); }}>Careers</button>
                </li>
                <li>
                  <button onClick={(e) => { e.preventDefault(); scrollToSection('home-section7'); }}>Reviews</button>
                </li>
                <li>
                  <button onClick={(e) => { e.preventDefault(); scrollToSection('home-section6'); }}>Contact</button>
                </li>
              </>
            )}
          </ul>

          <ul>
            {isAdminPath && isLoggedIn && (
              <>
                <li className="add-review-btn">
                  <button onClick={goToAddReview}>Add Review</button>
                </li>
                <li className="add-photos-btn">
                  <button onClick={goToAddPhotos}>Add Photos</button>
                </li>
                <li onClick={handleLogout}>
                  <FiLogOut />
                </li>
              </>
            )}
          </ul>
        </div>
      )}

      <div className="hamburger" onClick={toggleMenu}>
        <span className="bar"></span>
        <span className="bar"></span>
        <span className="bar"></span>
      </div>
    </header>
  );
};

export default Navbar;
